import React from "react";
import Countdown from "react-countdown";
const Completionist = () => <span>You are good to go!</span>;

const renderer = ({ days, hours, minutes, seconds, completed }) => {
  if (completed) {
    return <Completionist />;
  } else {
    return (
      <div id='clockdiv'>
        <div>
          <span className='days'>{days}</span>
          <div className='smalltext'>Days</div>
        </div>
        <div>
          <span className='hours'>{hours}</span>
          <div className='smalltext'>Hours</div>
        </div>
        <div>
          <span className='minutes'>{minutes}</span>
          <div className='smalltext'>Minutes</div>
        </div>
        <div>
          <span className='seconds'>{seconds}</span>
          <div className='smalltext'>Seconds</div>
        </div>
      </div>
    );
  }
};

const CountDown = () => {
  return (
    <div>
      <Countdown date={new Date(Date.now() + 1000000000)} renderer={renderer} />
    </div>
  );
};

export default CountDown;
